export const enum BleProviderEventTypes {
  INITIALIZE_SUCCESS,
  INITIALIZE_ERROR,
  ADD_DEVICE,
  DEVICE_ADDED,
  START_SCAN_ERROR,
  CLOSE,
  DISCONNECT,
  CONNECT,

  RECEIVE_VALUE,
  RECEIVE_ELECTRONIC_BLOOD_PRESSURE_MONITOR,
  RECEIVE_MEDICAL_BLOOD_PRESSURE_MONITOR,
  RECEIVE_ELECTRONIC_THERMOMETER,
  RECEIVE_BLOOD_SUGAR_LEVEL_MEASUREMENT,
  RECEIVE_SPO2_MONITOR_MIGHTY_SAT,
  RECEIVE_ECG_SERVICE,
  RECEIVE_SPO2_MONITOR_TM1121,
  RECEIVE_NONCONTACT_THERMOMETER,
  RECEIVE_BODY_COMPOSITION_MONITOR
}

export const enum BleProviderErrorCodes {
  TIMEOUT = 5000
}

export const enum BleConnectionStatus {
  DISCONNECTED = 'disconnected',
  LOGICALLY_CONNECTED = 'logicallyConnected',
  PENDING = 'pending',
  CONNECTED = 'connected'
}
